import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import "./Deeplink.css";
import openIC from "./image/open.svg";
import downloadIC from "./image/download.svg";
import QRIC from "./image/qr.svg";
import logo from "./image/logo.svg";

const Deeplink = () => {
  const location = useLocation();
  const initialTime = 60;
  const [timeLeft, setTimeLeft] = useState(initialTime);

  const handleFunction = () => {
    const pathSegments = location.pathname.split('/');
    const cardIndex = pathSegments.findIndex(segment => segment === 'cardscan');
    const cardId = cardIndex !== -1 ? pathSegments[cardIndex + 1] : null;

    if (!cardId) return;

    const fallback = {
      android: 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app',
      ios: `https://apps.apple.com/app/id6751297042`,
      web: `${window.location.origin}/rewardstick/cardscan/${cardId}`,
    };

    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    if (isAndroid) {
      const intentUrl = `intent://cardscan/${cardId}#Intent;scheme=rewardstick;package=com.ecologital.rewardstick_consumer_app;end`;
      window.location.href = intentUrl;

      setTimeout(() => {
        window.location.href = fallback.android;
      }, 1500);
    } else if (isIOS) {
      window.location.href = `rewardstick://cardscan/${cardId}`;

      setTimeout(() => {
        window.location.href = fallback.ios;
      }, 1500);
    } else {
      window.location.href = fallback.web;
    }
  };

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const cardIndex = pathSegments.findIndex(segment => segment === 'cardscan');
    const cardId = cardIndex !== -1 ? pathSegments[cardIndex + 1] : null;

    if (!cardId) return;

    const fallback = {
      android: 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app',
      ios: `https://apps.apple.com/app/id6751297042`,
      web: `${window.location.origin}/rewardstick/cardscan/${cardId}`,
    };

    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    if (isAndroid) {
      const intentUrl = `intent://cardscan/${cardId}#Intent;scheme=rewardstick;package=com.ecologital.rewardstick_consumer_app;end`;
      window.location.href = intentUrl;

      setTimeout(() => {
        window.location.href = fallback.android;
      }, 1500);
    } else if (isIOS) {
      window.location.href = `rewardstick://cardscan/${cardId}`;

      setTimeout(() => {
        window.location.href = fallback.ios;
      }, 1500);
    }
  }, [location]);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  return (
    <div className='Deeplink'>
      <img alt='' src={logo} className='Deeplink-logo-style' />

      <div className='Deeplink-container'>
        <div className='Deeplink-inner-container'>
          <div className='Deeplink-qr-wrapper'>
            <img alt='' src={QRIC} className='Deeplink-qr-img' />
          </div>
          <div className='Deeplink-inner-container-header'>
            Join using <div className='Deeplink-header-bold'>Rewardstick</div>
          </div>
          {timeLeft > 0 && (
            <div className='Deeplink-redirect-text'>
              Redirecting to your app
              <div className='Deeplink-timer-text'>
                {timeLeft > 0 ? `${timeLeft} sec(s)` : "...."}
              </div>
            </div>
          )}
          <div
            className='Deeplink-open-btn'
            onClick={handleFunction}
          >
            <img alt='' src={openIC} className='Deeplink-open-ic' />
            Open App
          </div>
          <a
            href='https://apps.apple.com/app/id6751297042'
            target='_blank'
            rel='noopener noreferrer'
            className='Deeplink-download-btn'
          >
            <img alt='' src={downloadIC} className='Deeplink-download-ic' />
            Download App
          </a>

          <div className='Deeplink-privacy-content'>
            <div>© 2025 Loyalty Scanner Inc. All rights reserved.</div>
            <div className='Deeplink-policy'>
              <span>Privacy Policy</span>
              <span>Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deeplink;
